import { render, staticRenderFns } from "./wxOpen.vue?vue&type=template&id=6902c18e&"
import script from "./wxOpen.vue?vue&type=script&lang=js&"
export * from "./wxOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports